module.exports = __webpack_public_path__ + "static/Claystack-256768bb30b6750cbf16011577722ac0.png";